<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('Invoice.invoice_updateRemark')"
      width="750px"
      class="make-invoice-adjust-balance-dialog"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div>
        <div class="app-el-transfer_text" align="center">
          <ul>
            <li>{{ $t('Clearing.PleaseNote') }}</li>
            <li />
            <li>{{ $t('Clearing.ChangesTheNextInvoiceConfiguration') }}</li>
            <li>{{ $t('Clearing.EBeLessThanCharacters') }}</li>
            <li>{{ $t('Clearing.PaperBeLessThanCharacters') }}</li>
            <li>{{ $t('Clearing.AutomaticTheTextDoesntLine') }}</li>
            <li>{{ $t('Clearing.PDFDisplayUpToLines') }}</li>
          </ul>
        </div>
        <div class="app-el-transfer">
          <template>
            <el-transfer id="transfer" ref="transfer" v-model="transferValue" :target-order="'push'" :data="listData" :titles="[$t('Clearing.NotUsed'), $t('Clearing.Used')]">
              <span slot-scope="{ option }" :draggable="!option.disabled" @dragstart="drag($event,option)">
                <label v-if="option.key == 18" class="app-el-transfer-label" :title="$t('Clearing.Example8180onlyUSDIsInvoice')">
                  {{ option.label }} <img :src="'/static/q.png'" width="13" height="13">
                </label>
                <label v-else class="app-el-transfer-label">
                  {{ option.label }}
                </label>
              </span>
            </el-transfer>
          </template>
        </div>
        <div class="triggers" align="center">
          <el-button type="primary" no="1" @click="saveConfig">
            {{ $t('common.btn.confirmUpdate') }}
          </el-button>

          <el-button type="primary" no="2" style="margin-left: 30px;" @click="cancel">
            {{ $t('common.btn.back') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import Sortable from 'sortablejs'
import {
  getInitializationConfig,
  updateInvoiceRemarkByConfig,
  getRemarkConfig
} from '@/api/sysManage/baseConfig/diyInvoiceRemark'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'InvoiceUpdateRemarkWindow',
  components: { CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    invoiceUuid: { type: String, required: true } // 发票唯一标识
  },
  data() {
    return {
      loading: false,
      draggingKey: null,
      transferValue: [],
      listData: [],
      rowData: [],
      initializationRowData: []
    }
  },
  computed: {
    innerVisible() {
      return this.visible
    }
  },
  async beforeMount() {

  },
  mounted() {
    this.getInitializationConfigFuc()
    this.refreshConfig()
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false)
    },
    // 初始化选中列表
    getInitializationConfigFuc() {
      const self = this
      this.loading = getLoading()
      getInitializationConfig().then(result => {
        self.iList = new Array(result.data)[0]
        const data = []
        for (let i = 0; i <= self.iList.length - 1; i++) {
          data.push({
            key: i,
            label: ColumnUtils.invoiceRemarkLabelFun(self.iList[i])
          })
        }
        this.listData = data
      }).finally(
        self.loading.close()
      )
    },
    // 刷新页面
    refreshConfig() {
      const value = this.$store.getters.currentOfficeId
      this.getRemarkConfigFunc(value)
    },
    getRemarkConfigFunc(value) {
      const self = this
      this.loading = getLoading()
      getRemarkConfig(value).then(result => {
        if (result.data !== null) {
          this.transferValue = result.data.list
          // 防止初始化分公司没有默认数据
          if (this.transferValue === undefined) {
            this.transferValue = []
          }
          this.draggingKey = null
        }
      }).finally(
        self.loading.close()
      )
    },
    drag(ev, option) {
      this.draggingKey = option.key
      const transfer = this.$refs.transfer.$el
      const leftPanel = transfer.getElementsByClassName('el-transfer-panel')[0].getElementsByClassName('el-transfer-panel__body')[0]
      const rightPanel = transfer.getElementsByClassName('el-transfer-panel')[1].getElementsByClassName('el-transfer-panel__body')[0]
      const rightEl = rightPanel.getElementsByClassName('el-transfer-panel__list')[0]
      // 右边上下拖拽
      Sortable.create(rightEl, {
        onEnd: (evt) => {
        }
      })
      // 左边拖拽
      leftPanel.ondragover = (ev) => {
        ev.preventDefault()
      }
      leftPanel.ondrop = (ev) => {
        ev.preventDefault()
        const index = this.transferValue.indexOf(this.draggingKey)
        if (index !== -1) {
          this.transferValue.splice(index, 1)
        }
      }
      // 右边拖拽
      rightPanel.ondragover = (ev) => {
        ev.preventDefault()
      }
      rightPanel.ondrop = (ev) => {
        ev.preventDefault()
        const value = this.transferValue
        const key = this.draggingKey
        if (value.indexOf(key) === -1) {
          this.transferValue.push(this.draggingKey)
        }
      }
    },
    saveConfig: async function() {
      const self = this
      self.branchId = this.$store.getters.currentOfficeId
      self.configs = []
      const transfer = this.$refs.transfer.$el
      const rightPanel = transfer.getElementsByClassName('el-transfer-panel')[1]
      for (let i = 0; i <= this.transferValue.length - 1; i++) {
        const num = rightPanel.getElementsByClassName('el-transfer-panel__item')[i].getElementsByClassName('el-checkbox__original')[0].value
        self.configs.push(Number(num))
      }
      self.invoiceUuid = this.invoiceUuid
      this.loading = getLoading()
      const saveData = { configs: self.configs, branchId: self.branchId, uuid: self.invoiceUuid }
      updateInvoiceRemarkByConfig(saveData).then(result => {
        this.$emit('updateRemarkCallBackEvent', this.invoiceUuid)
      }).finally(
        self.loading.close()
      )
    }
  }
}
</script>
<style scoped>

ul li{
  list-style: none;
  font-size: 13px;
  color: #909399;
}
.app-el-transfer{
  padding-left: 5%;
  padding-bottom: 30px;
}

.app-el-transfer_text{
  padding-right: 40px;
}
</style>

